export default __webpack_public_path__ + "20d00c1c8c362f0400f1a62423d30bb9.svg";